module.exports = __webpack_public_path__ + "static/media/02.452b4e19.png";